export default __webpack_public_path__ + "static/media/star.b5b8a3f8.svg";